<template>
    
    <div class="page-sidebar">
        <div class="last-mod-user" v-if="!isEditing">
            <img class="user-avatar" :src="userAvatarImg" alt="" />
            <div class="user-name">{{ lastModUser && lastModUser.fullName ? lastModUser.fullName : 'Unknown User' }}</div>
        </div>
        <page-toolbar
            :isEditing="isEditing"
            :isHomepage="isHomepage"
            :isPrivate="isPrivate"
            :isDeleted="isDeleted"
            :selectedRevision="selectedRevision"
            :latestKnownRevision="latestKnownRevision"
            :guid="guid"
            @toggle-edit="$emit('toggle-edit')"
            @cancel-edit="$emit('cancel-edit')"
            @save-edit="$emit('save-edit')"
            @make-page-private="$emit('make-page-private')"
            @make-page-public="$emit('make-page-public')"
            @selected-revision="handleSelectedRevision"
            @delete-page="$emit('delete-page')"
            @restore-revision="$emit('restore-revision')"
        />
    </div>

</template>


<script>

    import PageToolbar from './PageToolbar.vue'

    export default {
        name: 'page-sidebar',
        props: ['guid', 'lastModUser', 'lastModDate', 'isEditing', 'isHomepage', 'isPrivate', 'isDeleted', 'selectedRevision', 'latestKnownRevision'],
        components: {
            'page-toolbar': PageToolbar
        },
        computed: {
            userAvatarImg() {
                if (this.lastModUser && this.lastModUser.shortid) {
                    return `/wiki/users/${this.lastModUser.shortid}/avatar`
                } else {
                    return '/img/user-pic.jpg'
                }
            }
        },
        methods: {
            handleSelectedRevision(rev) {
                this.$emit('selected-revision', rev)
            }
        }
    }

</script>


<style lang="scss">

    .page-sidebar {
        position: -webkit-sticky;
        position: sticky;
        float: left;
        top: 30px;
        height: 40vh; /* enough to overlap */
        width: $sidebar-width;
        border-right: 2px solid $page-border-color;

        @include mobile {
            position: static;
            float: none;
            top: auto;
            bottom: 0;
            width: 100%;
            height: auto;
            text-align: center;
        }

        @include mobile-landscape {
            display: none;
        }

        .last-mod-user {
            position: sticky calc(114px + 30px);
            width: 121px;
            margin: 0 auto;

            @include mobile {
                display: none;
            }

            @media (max-height: 500px) {
                display: none;
            }

            .user-avatar {
                display: block;
                width: 88px;
                height: 88px;
                margin: 0 auto;
                border-radius: 44px;
                box-shadow: 0 0 1px $body-text-color;
            }

            .user-name {
                font-size: 16px;
                line-height: 16px;
                margin-top: 10px;
                text-align: center;
            }
        }
    }

</style>
